import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=1436999c&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1436999c')) {
      api.createRecord('1436999c', component.options)
    } else {
      api.reload('1436999c', component.options)
    }
    module.hot.accept("./ActivityDetail.vue?vue&type=template&id=1436999c&", function () {
      api.rerender('1436999c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivityDetail.vue"
export default component.exports